import { render, staticRenderFns } from "./bdmProfile.vue?vue&type=template&id=7e4c8dc1&scoped=true&"
import script from "./bdmProfile.vue?vue&type=script&lang=js&"
export * from "./bdmProfile.vue?vue&type=script&lang=js&"
import style0 from "./bdmProfile.vue?vue&type=style&index=0&id=7e4c8dc1&prod&scoped=true&lang=css&"
import style1 from "./bdmProfile.vue?vue&type=style&index=1&id=7e4c8dc1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4c8dc1",
  null
  
)

export default component.exports